import { SelectOption } from "./types";

export const Positions = [
    { id: 0, text: "Dental Hygienist" },
    { id: 1, text: "Dental Assistant" },
    { id: 2, text: "Admin/Front Desk" },
    { id: 3, text: "Associate Dentist" },
] as const satisfies SelectOption[];
export type PositionId = (typeof Positions)[number]['id'];
export function isValidPositionId(id: number): id is PositionId {
  return Positions.some(position => position.id === id);
}
export function assertValidPositionId(id: number): asserts id is PositionId {
  if (!isValidPositionId(id)) {
    throw new Error(`Invalid position ID: ${id}. Valid IDs are: ${Positions.map(p => p.id).join(', ')}`);
  }
}
export function findPositionById(id: number) {
  if (isValidPositionId(id)) {
    return Positions.find(position => position.id === id);
  }
  return null;
}

export const Basis = [
    { id: 0, text: "Permanent" },
    { id: 1, text: "Maternity Leave" },
    { id: 2, text: "Contract" },
] as const satisfies SelectOption[];
export type BasisId = (typeof Basis)[number]['id'];
export function isValidBasisId(id: number): id is BasisId {
  return Basis.some(basis => basis.id === id);
}
export function assertValidBasisId(id: number): asserts id is BasisId {
  if (!isValidBasisId(id)) {
    throw new Error(`Invalid basis ID: ${id}. Valid IDs are: ${Basis.map(b => b.id).join(', ')}`);
  }
}
export function findBasisById(id: number) {
  if (isValidBasisId(id)) {
    return Basis.find(basis => basis.id === id);
  }
  return null;
}

export const Days = [
    { id: 0, text: "Monday" },
    { id: 1, text: "Tuesday" },
    { id: 2, text: "Wednesday" },
    { id: 3, text: "Thursday" },
    { id: 4, text: "Friday" },
    { id: 5, text: "Saturday" },
    { id: 6, text: "Sunday" },
] as const satisfies SelectOption[];
export type DayId = (typeof Days)[number]['id'];
export function isValidDayId(id: number): id is DayId {
  return Days.some(day => day.id === id);
}
export function assertValidDayId(id: number): asserts id is DayId {
  if (!isValidDayId(id)) {
    throw new Error(`Invalid day ID: ${id}. Valid IDs are: ${Days.map(d => d.id).join(', ')}`);
  }
}
export function findDayById(id: number) {
  if (isValidDayId(id)) {
    return Days.find(day => day.id === id);
  }
  return null;
}

export const Requirements = [
    { id: 0, text: 'New Graduates Welcome' },
    { id: 1, text: '1 Year' },
    { id: 2, text: '2 Years' },
    { id: 3, text: '3 Years' },
    { id: 4, text: '4 Years' },
    { id: 5, text: '5+ Years' },
] as const satisfies SelectOption[];
export type RequirementId = (typeof Requirements)[number]['id'];
export function isValidRequirementId(id: number): id is RequirementId {
  return Requirements.some(requirement => requirement.id === id);
}
export function assertValidRequirementId(id: number): asserts id is RequirementId {
  if (!isValidRequirementId(id)) {
    throw new Error(`Invalid requirement ID: ${id}. Valid IDs are: ${Requirements.map(r => r.id).join(', ')}`);
  }
}
export function findRequirementById(id: number) {
  if (isValidRequirementId(id)) {
    return Requirements.find(requirement => requirement.id === id);
  }
  return null;
}

export const dayLabels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const;
